
<div [ngClass]="{'side-drawer': open}" [hidden]="!open">
  <div class="overlay" (click)="onCloseDrawer()" *ngIf="open"></div>
  <div class="drawer-content right-side" [style.width.px]="drawerWidth" [hidden]="!open">
    <ng-template skSideDrawerContentHost></ng-template>
    <ng-content *ngIf="open"></ng-content>
  </div>
</div>
